/* Tabs.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJZeqy%7Bgrid-area%3Atabs%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._2YLqiKQRM5%7Bmargin-inline%3Avar(--ds-space-negative-300%2C-24px)%7D%0A._43nrzT2ADO%7Bmargin-block-start%3Avar(--ds-space-100%2C8px)%7D");




import React from 'react';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
const compiledWrapperStyles = {
  root: "_1xC2CJZeqy _4bt5LAnQyn _2WAcuGnQyn"
};
const compiledInnerStyles = {
  root: "_2YLqiKQRM5 _43nrzT2ADO"
};
export const Tabs = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return <CompiledBox xcss={compiledWrapperStyles.root}>
			<CompiledBox xcss={compiledInnerStyles.root}>{children}</CompiledBox>
		</CompiledBox>;
};